import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Galary = (props: any) => {
  const { data, pagename } = props;
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: true,
    draggable: true,
    centerMode: true,
    variableWidth: true,
    centerPadding: "0%",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          dots: false,
          infinite: true,
          speed: 500,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: false,
          arrows: true,
          draggable: true,
          centerMode: true,
          variableWidth: true,
          centerPadding: "0%",
        },
      },
      {
        breakpoint: 760,
        settings: {
          dots: false,
          infinite: true,
          speed: 500,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: false,
          arrows: true,
          draggable: true,
          centerMode: true,
          variableWidth: true,
          centerPadding: "0%",

        },
      },
      {
        breakpoint: 500,
        settings: {
          dots: false,
          infinite: true,
          speed: 500,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: false,
          arrows: true,
          draggable: true,
          centerMode: true,
          centerPadding: "0%",
          variableWidth: true,
        },
      },
      {
        breakpoint: 430,
        settings: {
          dots: false,
          infinite: true,
          speed: 500,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: false,
          arrows: true,
          draggable: true,
          centerMode: true,
          centerPadding: "0%",
          variableWidth: true,
        },
      },
      {
        breakpoint: 360,
        settings: {
          dots: false,
          infinite: true,
          speed: 500,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: false,
          arrows: true,
          draggable: true,
          centerMode: true,
          centerPadding: "0%",
          variableWidth: true,
        },
      }
    ],
  };

  return (
    <>
      <div
        className={
          pagename === "new-octave"
            ? "new_octave_title_padding_bottom "
            : "galary-container"
        }
      >
        {/* className="headingText" */}
        <h2
          className={
            pagename === "new-octave"
              ? "new_octave_collection_title new_octave_title_margin_bottom"
              : " headingText"
          }
        >
          {data?.header}
        </h2>
        <div className="gallery_slider_man">
          <Slider {...settings}>
            {data?.items.map((item: any, index: any) => {
              return (
                <div key={index} className="gallary-image-wrapper">
                  <img
                    src={
                      item?.media?.data ? item.media.data.attributes.url : ""
                    }
                    alt="gallery image"
                  />
                </div>
              );
            })}
          </Slider>
        </div>
      </div>
    </>
  );
};

export default Galary;
